import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import Header from "src/Component/content-component/Header";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const DynamicUniversityDetails = ({ data = [] }) => {
  const handleReadMoreClick = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      console.warn("No URL provided for this item.");
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 5, textAlign: "center" }}>
        <Header content={"University Details"} color="#00999E" />
        <Box sx={{ flexGrow: 1, p: 3, padding: "40px 0px" }}>
          <Grid container spacing={2} columns={14} justifyContent="center">
            {data.map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <Box
                  textAlign="center"
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    pt: 2,
                    flexDirection: "column",
                    alignItems: "center",
                    border: {
                      md:"2px solid #c1c1c1",
                      xs: "none",
                    },
                    height: "220px",
                    cursor: item.url ? "pointer" : "default",
                    "&:hover": {
                      backgroundColor: item.url ? "#f5f5f5" : "inherit",
                    },
                  }}
                  onClick={
                    item.url ? () => handleReadMoreClick(item.url) : undefined
                  }
                  role={item.url ? "button" : "presentation"}
                  tabIndex={item.url ? 0 : -1}
                  onKeyDown={(e) => {
                    if (item.url && e.key === "Enter") {
                      handleReadMoreClick(item.url);
                    }
                  }}
                >
                  <Box height={"50px"}>
                    <img
                      src={
                        item.image ||
                        `${imageBaseUrl}universityinfo/default.png`
                      }
                      alt={item.title || "University Image"}
                      style={{ maxHeight: "100%", maxWidth: "100%" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontSize={"18px"}
                      sx={{ maxWidth: "250px" }}
                    >
                      {item.title || "No Title"}
                    </Typography>
                    <Typography variant="body1" sx={{ maxWidth: "250px" }}>
                      {item.subtitle || "No Subtitle"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default DynamicUniversityDetails;
